// ported from https://github.com/react-bootstrap/react-bootstrap/blob/f11723114d532cfce840417834a73733a8436414/src/CloseButton.tsx
import { mergeProps, splitProps } from "solid-js";
import classNames from "./classnames";
const defaultProps = {
    "aria-label": "Close",
};
const CloseButton = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), ["class", "variant"]);
    return (<button type="button" class={classNames("btn-close", local.variant && `btn-close-${local.variant}`, local.class)} {...props}/>);
};
export default CloseButton;
